__turbopack_context__.v({
  "boxWrapper": "MQh72W_boxWrapper",
  "buttonWrapper": "MQh72W_buttonWrapper",
  "cardContainer": "MQh72W_cardContainer",
  "checkboxCard": "MQh72W_checkboxCard",
  "checkboxGroup": "MQh72W_checkboxGroup",
  "contentWrapper": "MQh72W_contentWrapper",
  "contract": "MQh72W_contract",
  "contractCard": "MQh72W_contractCard",
  "contractCard__agb": "MQh72W_contractCard__agb",
  "contractCard__body": "MQh72W_contractCard__body",
  "contractCard__data": "MQh72W_contractCard__data",
  "contractCard__subHeadline": "MQh72W_contractCard__subHeadline",
  "contractConclusion": "MQh72W_contractConclusion",
  "contractInfoCard": "MQh72W_contractInfoCard",
  "contractInfo__body": "MQh72W_contractInfo__body",
  "contractInfo__headline": "MQh72W_contractInfo__headline",
  "contractInfo__row": "MQh72W_contractInfo__row",
  "contractInfo__subHeadline": "MQh72W_contractInfo__subHeadline",
  "floatingSubmitButton": "MQh72W_floatingSubmitButton",
  "greeting": "MQh72W_greeting",
  "headline": "MQh72W_headline",
  "headline__text": "MQh72W_headline__text",
  "intro": "MQh72W_intro",
  "label": "MQh72W_label",
  "legal__wrapper": "MQh72W_legal__wrapper",
  "orderButton": "MQh72W_orderButton",
  "orderCard": "MQh72W_orderCard",
  "productInfo": "MQh72W_productInfo",
  "unit": "MQh72W_unit",
  "value": "MQh72W_value",
  "values": "MQh72W_values",
});
